$(document).ready(function(){

  //Product Embedder
  $('.product-embed').each(function(){
    var $this = $(this);
    var product_handle = $this.data('product');

    
    
    if (typeof product_handle !== "undefined") {

      var loading_image = '//artsory.com/cdn/shop/t/17/assets/preloader.gif?v=77008736554601496081775475861';
      
      $this.html('<div style="width:100%;text-align:center;"><img style="width:auto" src="'+loading_image+'"></div>');

      jQuery.getJSON('/products/'+product_handle+'.js', function(product) {
        
        console.log(product);

        var format_money = $('body').data('money-format');
        var product_price = Shopify.formatMoney(product.price,format_money);
        
        if(product.available){
         
          var html_code = '';
          html_code += '<div class="product-embedded-wrap">';
            html_code += '<div class="image-wr">';
              html_code += '<img src="'+product.featured_image+'&width=800" />';
            html_code += '</div>';
            html_code += '<h3 class="title-wr">'+product.title+'</h3>';
            html_code += '<span class="price-wr">'+product_price+'</span>';
            html_code += '<a href="/products/'+product_handle+'" class="add-to-cart-wr js_addtc single_add_to_cart_button" data-id="'+product.variants[0].id+'" rel="nofollow"><span>Add to cart</span></a>';
            
          html_code += '</div>';
          $this.html(html_code);
        }else{
          $this.remove();
        }  
        
      });
      
      
    }
  });
  

});

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};





